module.exports = __webpack_public_path__ + "static/media/explorador_d.24f61f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/explorador_d.png
// module id = 1178
// module chunks = 0